<script>
    /**@type {? import ('$lib/types/errorMessages').errorMessage}*/
    export let errorMessage;
</script>

<div>
    {#if errorMessage}
        <div class="error error-message">
            {#if errorMessage.error}
                <div class="error-true">
                    <p>{errorMessage.msg}</p>
                </div>
            {:else}
                <div class="error-false">
                    <p>{errorMessage.msg}</p>
                </div>
            {/if}
        </div>
    {:else}
        <div class="error"></div>
    {/if}
</div>

<style>
    .error{
        opacity: 0;
    }
    .error-message{
        opacity: 1;
        margin: 0 auto 20px auto;
        width: 90%;
        transition: all 0.5s ease;
    }
    .error-true {
        color: #fff;
        background-color: #fb6161;
    }
    .error-false{
        background-color: rgb(0, 150, 0);
        color: #fff;
    }
    p {
        font-size: .9em;
        padding: 10px 5px;
        text-align: center;
    }
</style>
